var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-screen 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3327 12.918C10.1407 12.918 9.94875 12.9915 9.8025 13.1377L3.75 19.191V15.6982C3.75 15.2835 3.41475 14.9482 3 14.9482C2.58525 14.9482 2.25 15.2835 2.25 15.6982V21.0007C2.25 21.4155 2.58525 21.7507 3 21.7507H8.3025C8.71725 21.7507 9.0525 21.4155 9.0525 21.0007C9.0525 20.586 8.71725 20.2507 8.3025 20.2507H4.81125L10.863 14.1982C11.1562 13.905 11.1562 13.431 10.863 13.1377C10.7167 12.9907 10.5247 12.918 10.3327 12.918Z",
    fill: "#2A374E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.0834 2.33203H15.7809C15.3662 2.33203 15.0309 2.66728 15.0309 3.08203C15.0309 3.49678 15.3662 3.83203 15.7809 3.83203H19.2729L13.1364 9.96853C12.8432 10.2618 12.8432 10.7358 13.1364 11.029C13.4297 11.3223 13.9037 11.3223 14.1969 11.029L20.3334 4.89253V8.38453C20.3334 8.79928 20.6687 9.13453 21.0834 9.13453C21.4982 9.13453 21.8334 8.79928 21.8334 8.38453V3.08203C21.8334 2.66803 21.4982 2.33203 21.0834 2.33203Z",
    fill: "#2A374E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/fullScreen.3e56f28608fda94a3b1255908cea278b.svg";
export { ForwardRef as ReactComponent };